export const smproConstants = {
    SET_DEW_HEATER_VALUES: "SET_DEW_HEATER_VALUES"
};
